import {LabeledText} from "./helpers";
import {Container} from "./parcel";
import {parseStringArray} from "./building";
import {DialogTrigger} from "../../../components/ui/dialog";
import {Tooltip} from "../../../components/ui/tooltip";

function Apartment({ apartment, registerDetailsState, kw }) {
    const [, setRegisterDetails] = registerDetailsState;
    const { numer_lokalu, numer_budynku, ulica, miejscowosc_text, gmina, powiat } = apartment;

    return <Tooltip
        showArrow
        content="Kliknij aby zobaczyć szczegóły"
        openDelay={200}
        closeDelay={100}
        contentProps={{ css: { "--tooltip-bg": "#6f1d39" } }}
    >
        <DialogTrigger asChild>
            <Container
                color="#D1DDD2"
                onClick={() => setRegisterDetails({
                    type: 'apartment',
                    data: {
                        ...apartment,
                        kw
                    }
                })}
            >
                <LabeledText label="Nr. lokalu" value={numer_lokalu} />
                <LabeledText label="Nr. budynku" value={numer_budynku} />
                <LabeledText label="Ulica" value={ulica} />
                {miejscowosc_text && <LabeledText label="Miejscowość" value={miejscowosc_text} />}
                {!miejscowosc_text && gmina.length > 0 && <LabeledText label="Gmina" value={parseStringArray(gmina)} />}
                {!miejscowosc_text && !gmina.length && powiat.length > 0 && <LabeledText label="Powiat" value={parseStringArray(powiat)} />}
            </Container>
        </DialogTrigger>
    </Tooltip>
}

export default Apartment;
